/* Brightcode Wishlist — localStorage favourites with cross-tab sync.
 * Stores product handles (capped). Header bubble + drawer update automatically.
 *
 * Public API (window.BcWishlist):
 *   read(), has(handle), toggle(handle), remove(handle), clear()
 *   open(), close()
 *
 * DOM:
 *   [data-bc-wl="<handle>"]  — toggle heart
 *   [data-bc-wl-count]       — count bubble (hidden at 0)
 *   [data-bc-wl-count-text]  — always-visible count text
 *   [data-bc-wl-plural-s]    — plural "s" (hidden at 1)
 *   [data-bc-wl-open]        — open drawer
 *   [data-bc-wl-close]       — close drawer
 *   [data-bc-wl-drawer]      — drawer root
 *   [data-bc-wl-list]        — list container
 *   [data-bc-wl-empty]       — empty state
 *   [data-bc-wl-remove]      — remove handle from drawer
 */
(function () {
  if (window.BcWishlist) return;

  var KEY = 'bc-wishlist-v1';
  var MAX = 100;

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function write(arr) {
    if (arr.length > MAX) arr = arr.slice(0, MAX);
    try {
      localStorage.setItem(KEY, JSON.stringify(arr));
    } catch (e) {}
    notify();
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    if (!handle) return false;
    var arr = read();
    var i = arr.indexOf(handle);
    if (i === -1) {
      arr.unshift(handle);
      if (arr.length > MAX) arr = arr.slice(0, MAX);
    } else {
      arr.splice(i, 1);
    }
    write(arr);
    return arr.indexOf(handle) !== -1;
  }

  function remove(handle) {
    var arr = read();
    var i = arr.indexOf(handle);
    if (i !== -1) {
      arr.splice(i, 1);
      write(arr);
    }
  }

  function clear() {
    write([]);
  }

  function syncButton(btn) {
    var handle = btn.getAttribute('data-bc-wl');
    if (!handle) return;
    var active = has(handle);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.classList.toggle('is-active', active);
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-bc-wl]').forEach(syncButton);
  }

  function syncBubbles() {
    var count = read().length;
    document.querySelectorAll('[data-bc-wl-count]').forEach(function (el) {
      el.textContent = count;
      el.toggleAttribute('hidden', count === 0);
    });
    document.querySelectorAll('[data-bc-wl-count-text]').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('[data-bc-wl-plural-s]').forEach(function (el) {
      el.toggleAttribute('hidden', count === 1);
    });
  }

  function notify() {
    syncAllButtons();
    syncBubbles();
    document.dispatchEvent(
      new CustomEvent('bc-wishlist:change', { detail: { items: read() } })
    );
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-bc-wl]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-bc-wl'));
  });

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) {
      syncAllButtons();
      syncBubbles();
    }
  });

  function drawer() {
    return document.querySelector('[data-bc-wl-drawer]');
  }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    d.removeAttribute('hidden');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        d.setAttribute('data-open', 'true');
        d.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('bc-wl-locked');
        var closeBtn = d.querySelector('[data-bc-wl-close]');
        if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
      });
    });
    hydrateDrawer();
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.removeAttribute('data-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bc-wl-locked');
    setTimeout(function () {
      if (d.getAttribute('data-open') !== 'true') d.setAttribute('hidden', '');
    }, 280);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target && e.target.closest && e.target.closest('[data-bc-wl-open]');
    if (opener) {
      e.preventDefault();
      openDrawer();
      return;
    }
    var closer = e.target && e.target.closest && e.target.closest('[data-bc-wl-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    var remover = e.target && e.target.closest && e.target.closest('[data-bc-wl-remove]');
    if (remover) {
      e.preventDefault();
      var h = remover.getAttribute('data-bc-wl-remove');
      if (h) remove(h);
      return;
    }
    var atc = e.target && e.target.closest && e.target.closest('[data-bc-wl-atc]');
    if (atc) {
      e.preventDefault();
      addToCart(atc.getAttribute('data-bc-wl-atc'), atc);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = drawer();
      if (d && d.getAttribute('data-open') === 'true') closeDrawer();
    }
  });

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents, currency) {
    if (cents == null || isNaN(cents)) return '';
    var amount = (Number(cents) / 100).toFixed(2);
    return (currency ? currency + ' ' : '') + amount;
  }

  function cartRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function pickVariant(product) {
    var variants = (product && product.variants) || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i] && variants[i].available !== false) return variants[i];
    }
    return variants[0] || null;
  }

  function drawerRow(product) {
    var li = document.createElement('li');
    li.className = 'bc-wl-drawer__item';
    li.setAttribute('data-handle', product.handle);
    var imgUrl = product.image || '';
    var title = escapeHtml(product.title || product.handle);
    var priceHtml =
      product.price != null
        ? '<p class="bc-wl-drawer__price">' +
          escapeHtml(formatMoney(product.price, product.currency)) +
          '</p>'
        : '';
    var atcHtml = product.variantId
      ? '<button type="button" class="bc-wl-drawer__atc" data-bc-wl-atc="' +
        escapeHtml(String(product.variantId)) +
        '">Add to cart</button>'
      : '<a class="bc-wl-drawer__atc" href="' +
        escapeHtml(product.url) +
        '">View product</a>';
    var thumb = imgUrl
      ? '<a href="' +
        escapeHtml(product.url) +
        '"><img class="bc-wl-drawer__thumb" src="' +
        escapeHtml(imgUrl) +
        (imgUrl.indexOf('?') >= 0 ? '&' : '?') +
        'width=180" alt="' +
        title +
        '" loading="lazy" width="64" height="80"></a>'
      : '<span class="bc-wl-drawer__thumb"></span>';
    li.innerHTML =
      thumb +
      '<div class="bc-wl-drawer__meta">' +
      '<a class="bc-wl-drawer__title" href="' +
      escapeHtml(product.url) +
      '">' +
      title +
      '</a>' +
      priceHtml +
      atcHtml +
      '</div>' +
      '<button type="button" class="bc-wl-drawer__remove" data-bc-wl-remove="' +
      escapeHtml(product.handle) +
      '" aria-label="Remove ' +
      title +
      ' from wishlist">' +
      '<svg class="bc-wl-drawer__remove-icon" viewBox="0 0 20 20" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M11.5 9v4.25M8.5 9v4.25M5.75 12.2V6h8.5c0 2.421 0 3.779 0 6.2 0 .853 0 1.447-.038 1.91-.037.453-.106.714-.207.911a2.498 2.498 0 0 1-.983 1.017c-.197.1-.458.17-.911.207-.463.037-1.057.038-1.91.038h-.4c-.853 0-1.447 0-1.91-.038-.453-.037-.714-.106-.911-.207a2.498 2.498 0 0 1-.984-1.017c-.1-.197-.17-.458-.207-.911C5.75 13.647 5.75 13.053 5.75 12.2z" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>' +
      '<path d="M4.25 6h11.5M8 5.25a2 2 0 1 1 4 0" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '</button>';
    return li;
  }

  function publishCartUpdate(cart) {
    return import('@shopify/events')
      .then(function (mod) {
        var CartLinesUpdateEvent = mod.CartLinesUpdateEvent;
        var deferred = CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'wishlist',
            lines: [],
            promise: deferred.promise,
          })
        );
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            source: 'bc-wishlist',
            itemCount: 1,
            items: cart.items,
          },
        });
      })
      .catch(function () {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { source: 'bc-wishlist', cart: cart },
          })
        );
      });
  }

  function addToCart(variantId, btn) {
    if (!variantId || !btn || btn.dataset.bcBusy === '1') return;
    var root = cartRoot();
    var label = btn.textContent;
    btn.dataset.bcBusy = '1';
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
      }),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          throw new Error(res.data.description || res.data.message || 'Could not add to cart');
        }
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        return publishCartUpdate(cart).then(function () {
          return cart;
        });
      })
      .then(function () {
        btn.textContent = 'Added';
        setTimeout(function () {
          btn.textContent = label;
          btn.disabled = false;
          btn.dataset.bcBusy = '0';
        }, 1400);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        setTimeout(function () {
          btn.textContent = label;
          btn.disabled = false;
          btn.dataset.bcBusy = '0';
        }, 1600);
      });
  }

  function hydrateDrawer() {
    var d = drawer();
    if (!d) return;
    var listEl = d.querySelector('[data-bc-wl-list]');
    var emptyEl = d.querySelector('[data-bc-wl-empty]');
    var handles = read();
    if (!handles.length) {
      if (listEl) listEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (!listEl) return;
    listEl.innerHTML = '';
    handles.forEach(function (handle) {
      var ph = document.createElement('li');
      ph.className = 'bc-wl-drawer__item bc-wl-drawer__item--loading';
      ph.setAttribute('data-handle', handle);
      ph.innerHTML = '<span class="bc-wl-drawer__thumb"></span><span></span>';
      listEl.appendChild(ph);
      fetch('/products/' + encodeURIComponent(handle) + '.json', {
        headers: { Accept: 'application/json' },
      })
        .then(function (r) {
          if (!r.ok) throw new Error('missing');
          return r.json();
        })
        .then(function (data) {
          var p = data && data.product;
          if (!p) {
            ph.remove();
            remove(handle);
            return;
          }
          var v = pickVariant(p) || {};
          var cents = null;
          if (v.price != null) {
            /* product.json returns price as decimal string e.g. "2499.00" */
            cents = Math.round(parseFloat(v.price) * 100);
          }
          var img =
            (p.image && p.image.src) ||
            (p.images && p.images[0] && p.images[0].src) ||
            '';
          ph.replaceWith(
            drawerRow({
              handle: p.handle,
              title: p.title,
              url: '/products/' + p.handle,
              image: img,
              price: cents,
              variantId: v.id || null,
              currency:
                (window.Shopify &&
                  window.Shopify.currency &&
                  window.Shopify.currency.active) ||
                '',
            })
          );
        })
        .catch(function () {
          ph.remove();
          remove(handle);
        });
    });
  }

  function onReady() {
    syncAllButtons();
    syncBubbles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  document.addEventListener('bc-wishlist:change', function () {
    var d = drawer();
    if (d && d.getAttribute('data-open') === 'true') hydrateDrawer();
    else if (d) {
      var emptyEl = d.querySelector('[data-bc-wl-empty]');
      if (emptyEl) emptyEl.hidden = read().length > 0;
    }
  });

  document.addEventListener('shopify:section:load', function () {
    syncAllButtons();
    syncBubbles();
  });

  window.BcWishlist = {
    read: read,
    has: has,
    toggle: toggle,
    remove: remove,
    clear: clear,
    open: openDrawer,
    close: closeDrawer,
  };
})();
